<template>
  <picture v-lazyload v-if="src" class="responsive-image-wrapper">
    <source v-for="group in groups" :type="group"
            :sizes="finalSizes"
            :data-srcset="constructSrcSet( group )"/>
    <img class="img-responsive" :data-src="src" :title="title" :alt="alt" :style="pictureStyle" loading="lazy"/>
  </picture>
  <p v-else class="alert alert-danger small">Img not found</p>
</template>
<script>
/**
 * Responsive Image Component for use with concrete CMS Thumbnail system
 *
 * @property {object} availableThumbnails A Object containing the thumbnails that are available for a certain image
 * @example
 * //use with helper from mesch postinstaller like this:
 * :available-thumbnails='<?=\Concrete\Package\Travel\Helpers\Thumbnail::getThumbnails($f->getRecentVersion(), ['general_1000w','general_1900w','general_3800w']);?>'
 * @property {string} src Original src of the original image. - Used as fallback.
 * @property {string} aspectRatio Supply a aspect ratio to make sure the element is properly spaced and sized even if the image isn't loaded yet
 * @property {string} alt Alternative Text for image Tag
 * @property {string} title Title Text for image Tag
 */
export default {
  name: "responsive-concrete-image",
  props: {
    availableThumbnails: {
      type: Object
    },
    src: String,
    sizes: {
      type: Object,
      default: false
    },
    aspectRatio: String,
    debug: {
      type: Boolean,
      default: false
    },
    alt: String,
    title: String
  },
  data: function () {
    return {
      breakpoints: {
        xxl: 1400,
        xl: 1200,
        lg: 992,
        md: 768,
        sm: 576,
        xs: 0
      }
    }
  },
  methods: {
    constructSrcSet: function (group) {
      let sources = [];
      this.thumbnails.forEach(thumb => {
        if (group === thumb.filetype) {
          sources.push(thumb.path + ' ' + thumb.width + 'w');
        }
      })
      return sources.join(', ')
    }
  },
  computed: {
    groups: function () {
      let groups = [];
      this.thumbnails.forEach(thumbnail => {
        if (!groups.includes(thumbnail.filetype)) {
          groups.push(thumbnail.filetype);
        }
      })
      return groups;
    },
    finalSizes: function () {
      let sizes = [];
      for (const [key, value] of Object.entries(this.breakpoints)) {
        if (this.sizes[key] && key !== "xs") {
          sizes.push('(min-width: ' + value + 'px) ' + this.sizes[key])
        }
      }
      sizes.push('100vw');
      return sizes.join(', ');
    },
    thumbnails: function () {
      if (!this.availableThumbnails) return [];
      if (typeof this.availableThumbnails === 'string') {
        this.availableThumbnails = JSON.parse(this.availableThumbnails);
      }
      let availableThumbnailsArr = Object.values(this.availableThumbnails);
      let thumbnails = [];
      for (let i = 0; i < availableThumbnailsArr.length; i++) {
        let thumb = availableThumbnailsArr[i];
        thumbnails.push({
          type: thumb['type'],
          filetype: thumb['filetype'],
          path: thumb['path'],
          width: thumb['width']
        })
      }
      return thumbnails;
    },
    pictureStyle: function () {
      if (this.aspectRatio) {
        return 'aspect-ratio:' + this.aspectRatio;
      }
    }
  }
}
</script>
